import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bodyText", "buttonGroup", "darkScrim", "handleClose", "headlineText", "open", "subContent", "sx", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ErrorRounded, ErrorOutlineRounded } from '@mui/icons-material';
var DARK_SCRIM = 'rgba(67, 74, 79, .8)';
var LIGHT_SCRIM = 'rgba(67, 74, 79, .4)';
var FADE_TEXT = {
  webkitMaskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
  maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
  overflowY: 'scroll'
};

var TAGModal = function TAGModal(_ref) {
  var bodyText = _ref.bodyText,
      buttonGroup = _ref.buttonGroup,
      darkScrim = _ref.darkScrim,
      handleClose = _ref.handleClose,
      headlineText = _ref.headlineText,
      open = _ref.open,
      subContent = _ref.subContent,
      sx = _ref.sx,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  var modalThemeSwitchCase = function modalThemeSwitchCase(theme) {
    switch (theme) {
      case 'With Title':
        return React.createElement(DialogTitle, {
          sx: [{
            color: 'text.primary',
            px: {
              xs: '16px',
              sm: '40px'
            },
            pt: {
              xs: '24px',
              sm: '40px'
            }
          }, ASPENDENTAL_FONTS.h4]
        }, headlineText);

      case 'With Red Error Icon':
        return React.createElement(DialogTitle, {
          sx: {
            display: 'flex',
            justifyContent: 'center',
            paddingTop: {
              sm: '40px',
              xs: '32px'
            }
          }
        }, React.createElement(ErrorRounded, {
          sx: {
            color: 'error.dark',
            height: '40px',
            width: '40px'
          }
        }));

      case 'With Blue Error Icon':
        return React.createElement(DialogTitle, {
          sx: {
            display: 'flex',
            justifyContent: 'center',
            paddingTop: {
              sm: '40px',
              xs: '32px'
            }
          }
        }, React.createElement(ErrorOutlineRounded, {
          sx: {
            color: 'info.dark',
            height: '40px',
            width: '40px'
          }
        }));

      case 'Without Title':
        return;
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(Dialog, _objectSpread(_objectSpread({
    scroll: "paper",
    sx: [{
      '&.MuiModal-root': {
        backgroundColor: darkScrim ? DARK_SCRIM : LIGHT_SCRIM
      },
      '.MuiDialog-paperScrollPaper': {
        maxHeight: {
          xs: '70vh',
          sm: '60vh'
        }
      }
    }, sx]
  }, props), {}, {
    open: open,
    onClose: handleClose
  }), modalThemeSwitchCase(theme), React.createElement(DialogContent, {
    id: "MainContent",
    sx: [ASPENDENTAL_FONTS.bodyLargeBook, {
      color: 'text.secondary',
      px: {
        xs: '16px',
        sm: '40px'
      },
      pb: {
        xs: '20px',
        sm: '32px'
      }
    }, FADE_TEXT]
  }, React.createElement(DialogContentText, {
    sx: {
      pb: 6
    }
  }, bodyText)), subContent && React.createElement(DialogContent, {
    id: "SubContent"
  }, subContent), React.createElement(DialogActions, {
    sx: [{
      bgcolor: 'backgrounds.neutral',
      flexWrap: {
        xs: 'wrap-reverse'
      },
      paddingRight: {
        sm: '40px',
        xs: '16px'
      }
    }, sx]
  }, buttonGroup)));
};

export default TAGModal;